import buildReportFilename from './reportFilename';

/**
 * Generate and download a CSV report.
 */
const exportReportCsv = async ({
  config,
  columns,
  data,
  onProgress
}) => {
  try {
    if (onProgress) onProgress('Generating CSV...');

    const escapeCell = (val) => {
      if (val == null) return '';
      const str = String(val);
      // Escape if contains comma, quote, or newline
      if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const lines = [];

    // Header row
    lines.push(columns.map(col => escapeCell(col.label)).join(','));

    // Data rows
    data.forEach(row => {
      const cells = columns.map(col => {
        const camelField = col.field.charAt(0).toLowerCase() + col.field.slice(1);
        const displayKey = `${camelField}_Display`;
        const displayValue = row[displayKey] != null ? row[displayKey] : row[camelField];
        return escapeCell(displayValue);
      });
      lines.push(cells.join(','));
    });

    const csvContent = lines.join('\r\n');
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' }); // BOM for Excel compat

    const filename = buildReportFilename(config.reportName, 'csv');

    // Try File System Access API
    if (window.showSaveFilePicker) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: filename,
          types: [{
            description: 'CSV File',
            accept: { 'text/csv': ['.csv'] }
          }]
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        if (onProgress) onProgress(null);
        return true;
      } catch (err) {
        if (err.name === 'AbortError') {
          if (onProgress) onProgress(null);
          return false;
        }
      }
    }

    // Fallback
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    if (onProgress) onProgress(null);
    return true;
  } catch (err) {
    if (onProgress) onProgress(null);
    throw err;
  }
};

export default exportReportCsv;
